//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export enum SmartInputTrackingId {
  BaseInput = '-base-input',

  // Emojis
  OpenEmojiPickerActionBarButton = '-open-emoji-picker-action-bar-button',

  // Generative AI Caption
  GenerativeAiCaptionModal = '-generative-ai-caption-modal',
  GenerativeAiCaptionModalAddCaptionButton = '-generative-ai-caption-modal-add-caption-button',
  GenerativeAiCaptionModalCancelButton = '-generative-ai-caption-modal-cancel-button',
  GenerativeAiCaptionOpenModalActionBarButton = '-generative-ai-caption-open-modal-action-bar-button',

  // Generative AI Response
  GenerativeAiResponseActionBarButton = '-generative-ai-response-action-button',
  GenerativeAiResponseDropdownConfig = '-generative-ai-response-dropdown-menu',

  // Recommended Caption
  RecommendedCaptionActionBarButton = '-recommended-caption-action-button',
  RecommendedCaptionDropdownConfig = '-recommended-caption-dropdown-menu',

  // Recommended Hashtags
  AddRecommendedHashtag = '-add-recommended-hashtag',
  ShowRecommendedRecentHashtags = '-show-recommended-recent-hashtags',
  ShowRecommendedAiHashtags = '-show-recommended-ai-hashtags',
  CloseRecommenedHashtagsDropdownButton = '-close-recommended-hashtags-dropdown-button',
  OpenRecommendedHashtagsDropdownActionBarButton = '-open-recommended-hashtags-dropdown-action-bar-button',

  // Link Shortening
  ShortLinkAddLinkModal = '-short-link-add-link-modal',
  ShortLinkEditLinkModal = '-short-link-edit-link-modal',
  ShortLinkInlineShortenButton = '-short-link-inline-shorten-button',
  ShortLinkModalAddShortLinkButton = '-short-link-modal-add-short-link-button',
  ShortLinkModalCancelButton = '-short-link-modal-cancel-button',
  ShortLinkModalOriginalLinkInput = '-short-link-modal-original-link-input',
  ShortLinkModalPreviewLinkButton = '-short-link-modal-preview-link-button',
  ShortLinkModalUpdateShortLinkButton = '-short-link-modal-update-short-link-button',
  ShortLinkOpenModalActionBarButton = '-short-link-open-modal-action-bar-button',
  ShortLinkOpenModalInlineTooltipEditButton = '-short-link-open-modal-inline-tooltip-edit-button',

  // Mentions
  MentionsSuggestionsOpenDropdownActionBarButton = '-mentions-suggestions-open-dropdown-action-bar-button',
  MentionsSuggestionsAddMention = '-mentions-suggestions-add-mention',

  // Showroom Links
  ShowroomLinksActionBarButton = '-showroom-links-action-bar-button',
}
